import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter, Route } from 'react-router-dom';
import { persistStore } from 'redux-persist';
import { PersistGate } from 'redux-persist/integration/react';

// Local imports
import configureStore from '../../utils/ConfigureStore';
import AppView from './AppView';
import ErrorBoundary from './ErrorBoundary';

const store = configureStore({});
const persistor = persistStore(store);

export default class AppContainer extends React.Component {

  render() {
    return (
      <Provider store={store}>
        <ErrorBoundary>
          <PersistGate loading={null} persistor={persistor}>
            <BrowserRouter>
              <AppView />
            </BrowserRouter>
          </PersistGate>
        </ErrorBoundary>
      </Provider>
    );
  }
}
